$(function() {
    // Enable Tooltips
    $('body').tooltip({
        selector: '[data-toggle=tooltip]',
        placement: 'top'
    });

    // Enable Popovers
    $("[data-toggle=popover]").popover({
        html: true
    });
});


// WEBPACK FOOTER //
// ./resources/js/components/tooltips.js